export default __webpack_public_path__ + "static/media/bg-line-right.9ccf4d76.svg";